(function ($, me) {
    /**
    * enable fd controls at the page or element level
    *
    * @param { boolean } resetToolTips {resetToolTips:true} destroys page toolTips, default is true
    */
    $.fn.enableControls = function (options) {
        const currentOptions = $.extend({ resetToolTips: true }, options);
        //me.CONTROL.setValidateContainer(this); // Has to be run manually as it may target child elements.

        me.CONTROL.setAutoComplete(this);
        me.CONTROL.setButton(true, this);
        me.CONTROL.setCheckBox(true, this);
        me.CONTROL.setCounter(true, this);
        me.CONTROL.setDatePicker(this);
        me.CONTROL.setDropDown(true, this);
        me.CONTROL.setEditor(this);
        me.CONTROL.setNumber(true, this);
        me.CONTROL.setPopover(true, this);
        me.CONTROL.setRadioButton(this);
        me.CONTROL.setSelect(true, this);
        me.CONTROL.setSortable(this);
        //me.CONTROL.setStar(true, this); // Unused
        me.CONTROL.setStatus(true, this);
        //me.CONTROL.setTabbing(this, 0); // StartCell needs to be moved to attr.
        me.CONTROL.setTableFrozenColumn($('[data-fd=table-frozen-column]', this ?? 'body'));
        me.CONTROL.setTableInPage(this);
        me.CONTROL.setTableResize(this);
        me.CONTROL.setScroll(this); // Must be after tables.
        //me.CONTROL.setTableTab(this); // Unused
        me.CONTROL.setText(true, this);
        me.CONTROL.setTextArea(true, this);
        me.CONTROL.setTimePicker(this);
        //me.CONTROL.setTour(getTourSteps()); // Only used once
        me.CONTROL.setUrl(this);
        //me.CONTROL.setWebSocket(...) // This needs to be done explicitly in pages as the rules change.

        me.CONTROL.setExcelNavigation(null);
        if (currentOptions.resetToolTips) {
            me.setToolTipDestroy();
        }
        me.setToolTip(this);
        return this;
    };
}(jQuery, FD));